module.exports = __webpack_public_path__ + "img/f55.28258a5e.png";